/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type SequenceStepResponseScheduleDelayType = typeof SequenceStepResponseScheduleDelayType[keyof typeof SequenceStepResponseScheduleDelayType] | null;


export const SequenceStepResponseScheduleDelayType = {
  weekdays: 'weekdays',
  business_days: 'business_days',
  weeks: 'weeks',
  months: 'months',
} as const;
